import { useQuery } from '@tanstack/react-query';
import { getDevices, getDeviceById } from '@/api/endpoints/devices';

interface UseDevicesOptions {
  platform?: string;
  osVersion?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export const useDevices = (options?: UseDevicesOptions) => {
  return useQuery({
    queryKey: ['devices', options],
    queryFn: () => getDevices(options),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};

export const useDevice = (id: string) => {
  return useQuery({
    queryKey: ['device', id],
    queryFn: () => getDeviceById(id),
    staleTime: 1000 * 60 * 5,
    retry: 1,
    enabled: !!id,
  });
};
